import { lazier } from '@shared/components';

export const EagleProjectModal = lazier(
  () => import('./EagleProjectModal'),
  false,
);
export { default as EditEagleProjectButton } from './EditEagleProjectButton';
